export default __webpack_public_path__ + "static/media/bg-1.28d0b679.png";